module.exports = __webpack_public_path__ + "media/images/emblems/Rueti_bei_Lyssach-coat_of_arms-744a2f0c95e70179393647448629b668.svg";